import { use } from 'react';
import { ScheduleFlowContext, type ScheduleFlowContextType } from './ScheduleFlowContext';

export const useScheduleFlow = (): ScheduleFlowContextType => {
  const context = use(ScheduleFlowContext);
  if (context === undefined) {
    throw new Error('useScheduleFlow must be used within a ScheduleFlowProvider');
  }
  return context;
};
